import { fetchRequest, RequestMethod } from '@services/api/utils/utils';

export type UnlistedSpaceObject = {
  _id: string;
  unknownSpaceObjectId: number;
  cosparId?: string | null;
  noradId?: string | null;
  nationalId?: string | null;
  description?: string | null;
  createdBy: {
    userId: string;
    memberId: string;
  };
  createdAt: string;
  updatedAt: string;
};

export type UnlistedSpaceObjectConflict = {
  field: 'cosparId' | 'noradId' | 'nationalId';
  value: string;
  spaceObject: {
    _id: string;
    name: string;
    cosparId?: string;
    noradId?: string;
    nationalId?: string;
  };
};

type ConflictCheckResponse = {
  conflicts: UnlistedSpaceObjectConflict[];
};

type UnlistedSpaceObjectUpdatePayload = {
  cosparId?: string;
  noradId?: string;
  nationalId?: string;
  description?: string;
};

const getUnlistedSpaceObject = async (unknownSpaceObjectId: number): Promise<UnlistedSpaceObject> =>
  fetchRequest<UnlistedSpaceObject, UnlistedSpaceObject>({
    endpoint: `/unlisted-space-objects/${unknownSpaceObjectId}`,
    method: RequestMethod.GET,
    responseFormatter: data => data,
  });

const updateUnlistedSpaceObject = async (
  unknownSpaceObjectId: number,
  data: UnlistedSpaceObjectUpdatePayload,
): Promise<UnlistedSpaceObject> =>
  fetchRequest<UnlistedSpaceObject, UnlistedSpaceObject, UnlistedSpaceObjectUpdatePayload>({
    endpoint: `/unlisted-space-objects/${unknownSpaceObjectId}`,
    method: RequestMethod.PUT,
    body: data,
    responseFormatter: d => d,
  });

const checkUnlistedSpaceObjectConflicts = async (params: {
  cosparId?: string;
  noradId?: string;
  nationalId?: string;
}): Promise<ConflictCheckResponse> =>
  fetchRequest<ConflictCheckResponse, ConflictCheckResponse>({
    endpoint: '/unlisted-space-objects/check',
    method: RequestMethod.GET,
    query: params,
    responseFormatter: d => d,
  });

export const unlistedSpaceObjectsApi = {
  getUnlistedSpaceObject,
  updateUnlistedSpaceObject,
  checkUnlistedSpaceObjectConflicts,
};
